module.exports = __webpack_public_path__ + "img/land-turtle.74346491.jpg";